import React, { useState, useRef, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Chip,
  IconButton,
  Tooltip,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  TextField,
  InputAdornment,
  Divider,
  Badge,
  Alert,
  AlertTitle,
  Card,
  CardContent,
  CardActions,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Switch,
  FormControlLabel,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  ArrowBack as ArrowBackIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  WhatsApp as WhatsAppIcon,
  Send as SendIcon,
  Refresh as RefreshIcon,
  ExpandMore as ExpandMoreIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import api from '../../services/api';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`customer-whatsapp-tabpanel-${index}`}
      aria-labelledby={`customer-whatsapp-tab-${index}`}
      style={{
        width: '100%',
        flex: 1,
        minHeight: 0,
        display: value === index ? 'block' : 'none',
        overflow: 'auto',
      }}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2, width: '100%' }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return { id: `customer-whatsapp-tab-${index}`, 'aria-controls': `customer-whatsapp-tabpanel-${index}` };
}

const MOCK_CONVERSATIONS = [
  { id: 1, contact_name: 'Rahul Sharma', contact_phone: '+91 98765 11111', last_message_preview: 'Thanks, I am interested in a site visit', last_message_at: '2026-02-18T10:35:00Z', unread_count: 0 },
  { id: 2, contact_name: 'Priya Patel', contact_phone: '+91 87654 32222', last_message_preview: 'When can I get the brochure?', last_message_at: '2026-02-18T09:20:00Z', unread_count: 2 },
  { id: 3, contact_name: 'Amit Kumar', contact_phone: '+91 76543 33333', last_message_preview: 'Your site visit is confirmed for 20th Feb at 10 AM.', last_message_at: '2026-02-17T16:00:00Z', unread_count: 0 },
];

const MOCK_THREAD = [
  { id: 1, direction: 'outbound', content: 'Hi, here are the details for Skyline Apartments as requested. Please find the brochure and property images shared below.', timestamp: '2026-02-18T10:30:00Z' },
  { id: 2, direction: 'inbound', content: 'Thanks, I am interested in a site visit', timestamp: '2026-02-18T10:35:00Z' },
  { id: 3, direction: 'outbound', content: 'Your site visit is confirmed for 20th Feb at 10 AM. Visit location: Skyline Sales Office. Looking forward to meeting you!', timestamp: '2026-02-18T10:40:00Z' },
];

// Mock synced templates (templates already synced from WhatsApp)
const MOCK_SYNCED_TEMPLATES = [
  {
    id: 1,
    name: 'new_lead_intro_with_requirements',
    category: 'MARKETING',
    language: 'en_US',
    status: 'APPROVED',
    body_text: "Hi {{1}}, this is {{2}} from {{3}} regarding your enquiry for {{4}}. I'll be assisting you with property details and site visits.",
    variable_descriptions: [
      { var: '{{1}}', description: 'Customer Name' },
      { var: '{{2}}', description: 'Agent Name' },
      { var: '{{3}}', description: 'Company Name' },
      { var: '{{4}}', description: 'Requirements' },
    ],
    button_config: { buttons: [] },
  },
  {
    id: 2,
    name: 'property_interest_check',
    category: 'UTILITY',
    language: 'en_US',
    status: 'APPROVED',
    body_text: 'Hi {{1}}, did you get a chance to review {{2}} details?',
    variable_descriptions: [
      { var: '{{1}}', description: 'Customer name' },
      { var: '{{2}}', description: 'Project name' },
    ],
    button_config: {
      buttons: [
        { type: 'QUICK_REPLY', text: 'Interested' },
        { type: 'QUICK_REPLY', text: 'Not Interested' },
        { type: 'QUICK_REPLY', text: 'Need More Details' },
      ],
    },
  },
  {
    id: 3,
    name: 'send_single_project_details',
    category: 'UTILITY',
    language: 'en_US',
    status: 'APPROVED',
    body_text: 'Hi {{1}}, here are the details for {{2}} as requested. Please find the brochure and property images shared below.',
    variable_descriptions: [
      { var: '{{1}}', description: 'Customer name' },
      { var: '{{2}}', description: 'Project name' },
    ],
    button_config: {
      buttons: [
        { type: 'QUICK_REPLY', text: 'Interested' },
        { type: 'QUICK_REPLY', text: 'Not Interested' },
      ],
    },
  },
  {
    id: 4,
    name: 'site_visit_confirmed',
    category: 'UTILITY',
    language: 'en_US',
    status: 'PENDING',
    body_text: 'Hi {{1}}, your site visit with {{2}} is confirmed on {{3}} at {{4}}. Visit location is {{5}}, looking forward to meeting you.',
    variable_descriptions: [
      { var: '{{1}}', description: 'Customer name' },
      { var: '{{2}}', description: 'Agent name' },
      { var: '{{3}}', description: 'Visit date' },
      { var: '{{4}}', description: 'Visit time' },
      { var: '{{5}}', description: 'Visit location' },
    ],
    button_config: { buttons: [] },
  },
];

const MOCK_AUTO_MESSAGES = [
  { id: 1, name: 'Welcome message', trigger: 'First message from contact', template: 'welcome_message', enabled: true },
  { id: 2, name: 'Away message', trigger: 'Outside business hours', template: 'away_message', enabled: true },
  { id: 3, name: 'Lead created', trigger: 'New lead created in CRM', template: 'new_lead_intro_with_requirements', enabled: true },
  { id: 4, name: 'Quick reply - Interested', trigger: 'Keyword: interested', template: null, replyText: 'Thanks! We will schedule a call.', enabled: false },
];

const formatTime = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
};

const formatSyncTime = (isoString) => {
  if (!isoString) return 'Never';
  const date = new Date(isoString);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
  
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  
  return date.toLocaleDateString();
};

const CustomerConfigDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const messagesContainerRef = useRef(null);

  const [customer, setCustomer] = useState(() => {
    const stateCustomer = location.state?.customer;
    if (stateCustomer) {
      return {
        customer_name: stateCustomer.customer_name ?? stateCustomer.customerName,
        company_name: stateCustomer.company_name ?? stateCustomer.companyName,
        phone_number: stateCustomer.phone_number ?? stateCustomer.phoneNumber,
        phone_number_id: stateCustomer.phone_number_id,
        waba_id: stateCustomer.waba_id,
        waba_name: stateCustomer.waba_name,
        status: stateCustomer.status,
        last_synced_at: stateCustomer.last_synced_at,
        id: stateCustomer.id,
      };
    }
    return { customer_name: 'Loading...', company_name: '', phone_number: '', id };
  });
  const [detailLoading, setDetailLoading] = useState(!!id);
  const [detailError, setDetailError] = useState(null);

  const [value, setValue] = useState(0);
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [templateSearchQuery, setTemplateSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingMessages, setLoadingMessages] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [lastSyncedAt, setLastSyncedAt] = useState(() => {
    const c = location.state?.customer;
    return c?.last_synced_at ?? c?.lastSyncedAt ?? null;
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [previewDialog, setPreviewDialog] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [editingTemplate, setEditingTemplate] = useState(null);
  const [editFormData, setEditFormData] = useState({ name: '', body_text: '' });
  const [testDialog, setTestDialog] = useState(false);
  const [testTemplate, setTestTemplate] = useState(null);
  const [testPhone, setTestPhone] = useState('');
  const [sendingTest, setSendingTest] = useState(false);
  const [templateParams, setTemplateParams] = useState({});
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const [selectedTemplateDetail, setSelectedTemplateDetail] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [syncedTemplates, setSyncedTemplates] = useState([]);
  const [syncingTemplate, setSyncingTemplate] = useState(null);
  const [refreshingTemplate, setRefreshingTemplate] = useState(null);
  const [templateSubTab, setTemplateSubTab] = useState(0);
  const [deletingTemplate, setDeletingTemplate] = useState(null);
  const [tenantCopyDialogOpen, setTenantCopyDialogOpen] = useState(false);
  const [tenantCopyMasterId, setTenantCopyMasterId] = useState(null);
  const [tenantCopyTemplateName, setTenantCopyTemplateName] = useState('');
  const [tenantCopyForm, setTenantCopyForm] = useState({ body_text: '', header_text: '', footer_text: '', language: '', button_config: { buttons: [] }, variable_descriptions: [] });
  const [tenantCopyExpectedVariables, setTenantCopyExpectedVariables] = useState([]); // e.g. [1, 2, 3] for {{1}}, {{2}}, {{3}}
  const [tenantCopyValidationError, setTenantCopyValidationError] = useState(null);
  const [loadingTenantCopy, setLoadingTenantCopy] = useState(false);
  const [savingTenantCopy, setSavingTenantCopy] = useState(false);
  const [triggers, setTriggers] = useState([]);
  const [triggerDialogOpen, setTriggerDialogOpen] = useState(false);
  const [editingTrigger, setEditingTrigger] = useState(null);
  const [triggerFormData, setTriggerFormData] = useState({
    name: '',
    description: '',
    event_type: '',
    recipient_type: 'customer', // Always customer/leads
    template: '',
    template_name: '',
    template_language: 'en_US',
    delay_minutes: 0,
    delay_type: 'minutes', // 'minutes', 'hours', 'days', 'before_event'
    delay_before_event: false,
    is_active: true,
    conditions: {}, // JSON for filter rules
    conditions_json: '{}', // String representation for input
    template_params_mapping: {}, // Mapping of template variable numbers to context variable keys
    execution_policy: 'once_per_event', // 'once_per_event', 'once_per_lead', 'once_per_visit', 'unlimited'
    safety_guards: {
      check_wallet: false,
      check_consent: true,
      check_quality: false,
      min_lead_score: null,
    },
  });
  const [togglingTrigger, setTogglingTrigger] = useState(null);
  const [triggerWizardStep, setTriggerWizardStep] = useState(0);
  const [availableVariables, setAvailableVariables] = useState({});
  const [templateVariables, setTemplateVariables] = useState([]);
  const [selectedTemplateForMapping, setSelectedTemplateForMapping] = useState(null);
  // Per-tenant event toggles and custom rules
  const [triggerEventConfigs, setTriggerEventConfigs] = useState([]);
  const [loadingTriggerEventConfigs, setLoadingTriggerEventConfigs] = useState(false);
  const [savingEventKey, setSavingEventKey] = useState(null);
  const [eventConfigRuleEdits, setEventConfigRuleEdits] = useState({}); // event_key -> JSON string (dirty)

  // Extract template variables when template is selected (only when dialog is open)
  useEffect(() => {
    if (!triggerDialogOpen) return;
    
    if (triggerFormData.template && syncedTemplates.length > 0) {
      const template = syncedTemplates.find(t => String(t.id) === triggerFormData.template);
      if (template) {
        const currentTemplateId = selectedTemplateForMapping?.id;
        if (!currentTemplateId || String(currentTemplateId) !== String(template.id)) {
          console.log('[useEffect] Extracting variables for template:', template.name);
          extractTemplateVariables(template);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFormData.template, triggerDialogOpen]);

  // Fetch available variables when event type changes (only when dialog is open)
  useEffect(() => {
    if (!triggerDialogOpen) return;
    
    if (triggerFormData.event_type) {
      console.log('[useEffect] Fetching variables for event type:', triggerFormData.event_type);
      fetchAvailableVariables(triggerFormData.event_type);
    } else if (Object.keys(availableVariables).length === 0) {
      // If no event type but no variables loaded, fetch all variables
      console.log('[useEffect] No event type, fetching all variables');
      fetchAvailableVariables(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFormData.event_type, triggerDialogOpen]);


  useEffect(() => {
    if (!id) return;
    let cancelled = false;
    setDetailLoading(true);
    setDetailError(null);
    api
      .get(`/whatsapp/customer-configs/${id}/`)
      .then((res) => {
        if (cancelled || !res.data.success) return;
        const data = res.data.data || {};
        setCustomer({
          id: data.id,
          customer_name: data.customer_name,
          company_name: data.company_name,
          phone_number: data.phone_number,
          phone_number_id: data.phone_number_id,
          waba_id: data.waba_id,
          waba_name: data.waba_name,
          status: data.status,
          last_synced_at: data.last_synced_at,
        });
        if (data.last_synced_at) setLastSyncedAt(data.last_synced_at);
      })
      .catch((err) => {
        if (!cancelled) {
          setDetailError(err.response?.data?.error || 'Failed to load customer configuration');
        }
      })
      .finally(() => {
        if (!cancelled) setDetailLoading(false);
      });
    return () => { cancelled = true; };
  }, [id]);

  // Fetch conversations when account id is available
  useEffect(() => {
    if (!id) return;
    fetchConversations();
    // Poll for new conversations every 30 seconds
    const interval = setInterval(fetchConversations, 30000);
    return () => clearInterval(interval);
  }, [id]);

  // Fetch templates for this customer when Templates tab is active (index 0)
  useEffect(() => {
    if (value === 0 && id) {
      fetchTemplates();
    }
  }, [value, id]);

  // Fetch event configs for this customer when Message Triggers tab is active (index 1)
  useEffect(() => {
    if (value === 1 && id) {
      fetchTriggerEventConfigs();
    }
  }, [value, id]);

  const fetchConversations = async () => {
    if (!id) return;
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/whatsapp/customer-configs/${id}/conversations/`, {
        params: { search: searchQuery },
      });
      if (response.data.success) {
        setConversations(response.data.conversations || []);
      }
    } catch (err) {
      console.error('Error fetching conversations:', err);
      setError(err.response?.data?.error || 'Failed to load conversations');
    } finally {
      setLoading(false);
    }
  };

  const fetchMessages = async (conversationId) => {
    if (!id || !conversationId) return;
    try {
      setLoadingMessages(true);
      const response = await api.get(`/whatsapp/customer-configs/${id}/conversations/${conversationId}/messages/`);
      if (response.data.success) {
        setMessages(response.data.messages || []);
      }
    } catch (err) {
      console.error('Error fetching messages:', err);
      setError(err.response?.data?.error || 'Failed to load messages');
    } finally {
      setLoadingMessages(false);
    }
  };

  const fetchTemplates = async () => {
    if (!id) return;
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/whatsapp/customer-configs/${id}/templates/`);
      if (response.data && response.data.success) {
        setTemplates(response.data.templates || []);
        setSyncedTemplates(response.data.synced_templates || []);
      }
    } catch (err) {
      console.error('Error fetching templates:', err);
      setError(err.response?.data?.error || 'Failed to load templates');
      setTemplates([]);
      setSyncedTemplates([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSyncTemplate = async (template) => {
    const libraryId = template.library_id;
    if (!libraryId) return;
    try {
      setSyncingTemplate(libraryId);
      setError(null);
      const payload = { template_id: libraryId };
      const effectiveLanguage = (template.tenant_copy?.language != null && template.tenant_copy?.language !== '')
        ? template.tenant_copy.language
        : template.language;
      if (effectiveLanguage) payload.language = effectiveLanguage;
      const response = await api.post(`/whatsapp/customer-configs/${id}/templates/sync/`, payload);
      if (response.data && response.data.success) {
        setSuccess(`Template "${template.name}" synced successfully. It will be pending approval from WhatsApp.`);
        await fetchTemplates();
      }
    } catch (err) {
      console.error('Error syncing template:', err);
      setError(err.response?.data?.error || `Failed to sync template "${template.name}"`);
    } finally {
      setSyncingTemplate(null);
    }
  };

  /** Extract sorted variable numbers (e.g. [1, 2, 3]) from text containing {{1}}, {{2}}, etc. */
  const getVariableNumbersFromText = (text) => {
    if (!text || typeof text !== 'string') return [];
    const matches = text.match(/\{\{(\d+)\}\}/g) || [];
    const numbers = [...new Set(matches.map((m) => parseInt(m.replace(/\D/g, ''), 10)))].sort((a, b) => a - b);
    return numbers;
  };

  const handleOpenTenantCopy = async (template) => {
    const masterId = template.library_id || template.id;
    if (!id || !masterId) return;
    setTenantCopyMasterId(masterId);
    setTenantCopyTemplateName(template.name || '');
    setTenantCopyValidationError(null);
    setTenantCopyDialogOpen(true);
    setError(null);
    const body = template.body_text || template.tenant_copy?.body_text || '';
    const header = template.header_text || template.tenant_copy?.header_text || '';
    const footer = template.footer_text || template.tenant_copy?.footer_text || '';
    const expected = getVariableNumbersFromText(header + ' ' + body + ' ' + footer);
    setTenantCopyExpectedVariables(expected);
    if (template.has_tenant_copy && template.tenant_copy) {
      const c = template.tenant_copy;
      const btnConfig = c.button_config && typeof c.button_config === 'object' ? c.button_config : { buttons: [] };
      const varDescriptions = Array.isArray(c.variable_descriptions) ? c.variable_descriptions : [];
      setTenantCopyForm({
        body_text: c.body_text || '',
        header_text: c.header_text || '',
        footer_text: c.footer_text || '',
        language: c.language || '',
        button_config: { buttons: Array.isArray(btnConfig.buttons) ? btnConfig.buttons : [] },
        variable_descriptions: varDescriptions,
      });
      setLoadingTenantCopy(false);
      return;
    }
    setLoadingTenantCopy(true);
    try {
      const res = await api.post(`/whatsapp/customer-configs/${id}/templates/${masterId}/copy/`);
      if (res.data && res.data.success && res.data.tenant_copy) {
        const c = res.data.tenant_copy;
        const btnConfig = c.button_config && typeof c.button_config === 'object' ? c.button_config : { buttons: [] };
        const varDescriptions = Array.isArray(c.variable_descriptions) ? c.variable_descriptions : [];
        setTenantCopyForm({
          body_text: c.body_text || '',
          header_text: c.header_text || '',
          footer_text: c.footer_text || '',
          language: c.language || '',
          button_config: { buttons: Array.isArray(btnConfig.buttons) ? btnConfig.buttons : [] },
          variable_descriptions: varDescriptions,
        });
        await fetchTemplates();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create template copy');
    } finally {
      setLoadingTenantCopy(false);
    }
  };

  const handleSaveTenantCopy = async () => {
    if (!id || !tenantCopyMasterId) return;
    const combined = (tenantCopyForm.header_text || '') + ' ' + (tenantCopyForm.body_text || '') + ' ' + (tenantCopyForm.footer_text || '');
    const actualVariables = getVariableNumbersFromText(combined);
    const expected = tenantCopyExpectedVariables;
    const expectedStr = expected.length ? expected.map((n) => `{{${n}}}`).join(', ') : 'none';
    if (actualVariables.length !== expected.length || expected.some((v, i) => v !== actualVariables[i])) {
      setTenantCopyValidationError(
        `Variable placeholders must match the original template. Expected ${expected.length} variable(s): ${expectedStr}. You have ${actualVariables.length}: ${actualVariables.length ? actualVariables.map((n) => `{{${n}}}`).join(', ') : 'none'}.`
      );
      return;
    }
    setTenantCopyValidationError(null);
    setSavingTenantCopy(true);
    setError(null);
    try {
      const res = await api.patch(
        `/whatsapp/customer-configs/${id}/template-copies/${tenantCopyMasterId}/`,
        { body_text: tenantCopyForm.body_text, header_text: tenantCopyForm.header_text || null, footer_text: tenantCopyForm.footer_text || null, language: tenantCopyForm.language || null }
      );
      if (res.data && res.data.success) {
        setSuccess('Template wording updated. Sync to WhatsApp to push changes.');
        setTenantCopyDialogOpen(false);
        await fetchTemplates();
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save template copy');
    } finally {
      setSavingTenantCopy(false);
    }
  };

  const fetchTriggers = async () => {
    if (!id) return;
    try {
      setLoading(true);
      setError(null);
      const response = await api.get(`/whatsapp/customer-configs/${id}/triggers/`);
      if (response.data && response.data.success) {
        setTriggers(response.data.triggers || []);
      }
    } catch (err) {
      console.error('Error fetching triggers:', err);
      setError(err.response?.data?.error || 'Failed to load triggers');
      setTriggers([]);
    } finally {
      setLoading(false);
    }
  };


  const handleToggleTrigger = async (trigger) => {
    if (!id || !trigger.id) return;
    try {
      setTogglingTrigger(trigger.id);
      setError(null);
      const response = await api.post(`/whatsapp/customer-configs/${id}/triggers/${trigger.id}/toggle/`);
      if (response.data && response.data.success) {
        setSuccess(`Trigger ${response.data.is_active ? 'activated' : 'deactivated'} successfully`);
        await fetchTriggers();
      }
    } catch (err) {
      console.error('Error toggling trigger:', err);
      setError(err.response?.data?.error || `Failed to ${trigger.is_active ? 'deactivate' : 'activate'} trigger`);
    } finally {
      setTogglingTrigger(null);
    }
  };

  const handleDeleteTrigger = async (trigger) => {
    if (!id || !trigger.id) return;
    if (!window.confirm(`Are you sure you want to delete the trigger "${trigger.name}"?`)) {
      return;
    }
    try {
      setError(null);
      const response = await api.delete(`/whatsapp/customer-configs/${id}/triggers/${trigger.id}/`);
      if (response.data && response.data.success) {
        setSuccess(`Trigger "${trigger.name}" deleted successfully`);
        await fetchTriggers();
      }
    } catch (err) {
      console.error('Error deleting trigger:', err);
      setError(err.response?.data?.error || `Failed to delete trigger "${trigger.name}"`);
    }
  };

  const fetchTriggerEventConfigs = async () => {
    if (!id) return;
    try {
      setLoadingTriggerEventConfigs(true);
      setError(null);
      const response = await api.get(`/whatsapp/customer-configs/${id}/trigger-event-configs/`);
      if (response.data && response.data.success) {
        setTriggerEventConfigs(response.data.configs || []);
        setEventConfigRuleEdits({});
      }
    } catch (err) {
      console.error('Error fetching trigger event configs:', err);
      setError(err.response?.data?.error || 'Failed to load event configs');
      setTriggerEventConfigs([]);
    } finally {
      setLoadingTriggerEventConfigs(false);
    }
  };

  const updateTriggerEventConfig = async (eventKey, payload) => {
    if (!id || !eventKey) return;
    try {
      setSavingEventKey(eventKey);
      setError(null);
      const response = await api.patch(
        `/whatsapp/customer-configs/${id}/trigger-event-configs/${eventKey}/`,
        payload
      );
      if (response.data && response.data.success) {
        setSuccess('Event config saved');
        setTriggerEventConfigs((prev) =>
          prev.map((c) =>
            c.event_key === eventKey
              ? {
                  ...c,
                  enabled: response.data.data.enabled,
                  allowed_for_agent: response.data.data.allowed_for_agent,
                  custom_rule: response.data.data.custom_rule || {},
                }
              : c
          )
        );
        setEventConfigRuleEdits((prev) => {
          const next = { ...prev };
          delete next[eventKey];
          return next;
        });
      }
    } catch (err) {
      console.error('Error updating trigger event config:', err);
      setError(err.response?.data?.error || 'Failed to save event config');
    } finally {
      setSavingEventKey(null);
    }
  };

  const handleEventToggle = async (eventKey, enabled) => {
    await updateTriggerEventConfig(eventKey, { enabled });
  };

  const handleEventRuleSave = async (eventKey) => {
    const raw = eventConfigRuleEdits[eventKey];
    if (raw === undefined) return;
    let custom_rule = {};
    try {
      custom_rule = raw.trim() ? JSON.parse(raw) : {};
    } catch (e) {
      setError('Invalid JSON for custom rule');
      return;
    }
    await updateTriggerEventConfig(eventKey, { custom_rule });
  };

  const handleOpenTriggerDialog = async (trigger = null) => {
    // Ensure templates are loaded before opening dialog
    if (!syncedTemplates.length && id) {
      await fetchTemplates();
    }
    
    if (trigger) {
      // Fetch full trigger details to get complete template information
      try {
        const response = await api.get(`/whatsapp/customer-configs/${id}/triggers/${trigger.id}/`);
        const fullTrigger = response.data?.data || trigger;
        
        setEditingTrigger(fullTrigger);
        const conditions = fullTrigger.conditions || {};
        
        // Find template ID from synced templates by matching template name or ID
        let templateId = '';
        // In WhatsAppMessageTriggerSerializer, `template` is the FK id (number), not an object.
        if (fullTrigger.template) {
          templateId = String(fullTrigger.template);
        } else if (fullTrigger.template_details?.id) {
          templateId = String(fullTrigger.template_details.id);
        } else {
          // Try to find template by name in synced templates
          const templateName =
            fullTrigger.template_name ||
            fullTrigger.template_name_display ||
            fullTrigger.template_details?.name ||
            '';
          if (templateName) {
            const normalized = templateName.toLowerCase().replace(/\s+/g, '_');
            const matchedTemplate = syncedTemplates.find(
              (t) => t.name === templateName || t.name === normalized
            );
            if (matchedTemplate) {
              templateId = String(matchedTemplate.id);
            }
          }
        }
        
        setTriggerFormData({
          name: fullTrigger.name || '',
          description: fullTrigger.description || '',
          event_type: fullTrigger.event_type || '',
          recipient_type: 'customer', // Always customer
          template: templateId,
          template_name: fullTrigger.template_name || '',
          template_language: fullTrigger.template_language || 'en_US',
          delay_minutes: fullTrigger.delay_minutes || 0,
          delay_type: fullTrigger.delay_type || 'minutes',
          delay_before_event: fullTrigger.delay_before_event || false,
          is_active: fullTrigger.is_active !== undefined ? fullTrigger.is_active : true,
          conditions: conditions,
          conditions_json: JSON.stringify(conditions, null, 2),
          execution_policy: fullTrigger.execution_policy || 'once_per_event',
          safety_guards: fullTrigger.safety_guards || {
            check_wallet: false,
            check_consent: true,
            check_quality: false,
            min_lead_score: null,
          },
        });
      } catch (err) {
        console.error('Error fetching trigger details:', err);
        // Fallback to using the trigger data from list
        setEditingTrigger(trigger);
        const conditions = trigger.conditions || {};
        
        // Try to find template by name from list view
        let templateId = '';
        const templateName = trigger.template_name_display || trigger.template_name;
        if (templateName) {
          const matchedTemplate = syncedTemplates.find(
            t => t.name === templateName || t.name === templateName.toLowerCase().replace(/\s+/g, '_')
          );
          if (matchedTemplate) {
            templateId = String(matchedTemplate.id);
          }
        }
        
        setTriggerFormData({
          name: trigger.name || '',
          description: trigger.description || '',
          event_type: trigger.event_type || '',
          recipient_type: 'customer',
          template: templateId,
          template_name: trigger.template_name || '',
          template_language: trigger.template_language || 'en_US',
          delay_minutes: trigger.delay_minutes || 0,
          delay_type: trigger.delay_type || 'minutes',
          delay_before_event: trigger.delay_before_event || false,
          is_active: trigger.is_active !== undefined ? trigger.is_active : true,
          conditions: conditions,
          conditions_json: JSON.stringify(conditions, null, 2),
          template_params_mapping: trigger.template_params_mapping || {},
          execution_policy: trigger.execution_policy || 'once_per_event',
          safety_guards: trigger.safety_guards || {
            check_wallet: false,
            check_consent: true,
            check_quality: false,
            min_lead_score: null,
          },
        });
        
        // Extract template variables and fetch available variables when editing
        // Use useEffect to ensure templates are loaded
        if (trigger.event_type) {
          console.log('[handleEditTrigger] Fetching variables for event type:', trigger.event_type);
          fetchAvailableVariables(trigger.event_type);
        } else {
          // If no event type, fetch all variables
          console.log('[handleEditTrigger] No event type, fetching all variables');
          fetchAvailableVariables(null);
        }
        // Check if template exists in syncedTemplates, if not wait a bit
        if (templateId) {
          const template = syncedTemplates.find(t => String(t.id) === templateId);
          if (template) {
            extractTemplateVariables(template);
          } else {
            // If template not found yet, wait for templates to load
            setTimeout(() => {
              const template = syncedTemplates.find(t => String(t.id) === templateId);
              if (template) {
                extractTemplateVariables(template);
              }
            }, 500);
          }
        }
      }
    } else {
      setEditingTrigger(null);
      setTriggerFormData({
        name: '',
        description: '',
        event_type: '',
        recipient_type: 'customer', // Always customer
        template: '',
        template_name: '',
        template_language: 'en_US',
        delay_minutes: 0,
        delay_type: 'minutes',
        delay_before_event: false,
        is_active: true,
        conditions: {},
        conditions_json: '{}',
        template_params_mapping: trigger?.template_params_mapping || {},
        execution_policy: 'once_per_event',
        safety_guards: {
          check_wallet: false,
          check_consent: true,
          check_quality: false,
          min_lead_score: null,
        },
      });
      
      // If editing, extract template variables and fetch available variables
      if (trigger) {
        if (trigger.event_type) {
          fetchAvailableVariables(trigger.event_type);
        }
        if (trigger.template) {
          const template = syncedTemplates.find(t => t.id === trigger.template);
          if (template) {
            extractTemplateVariables(template);
          }
        }
      }
    }
    setTriggerWizardStep(0);
    setTriggerDialogOpen(true);
  };

  const fetchAvailableVariables = async (eventType) => {
    try {
      let url = '/lms/whatsapp/template-variables/';
      const params = {};
      if (eventType) {
        params.event_type = eventType;
      }
      if (id) {
        params.account_id = id;
      }
      
      console.log('[fetchAvailableVariables] Fetching from:', url, 'params:', params);
      const response = await api.get(url, { params });
      console.log('[fetchAvailableVariables] Response status:', response.status);
      console.log('[fetchAvailableVariables] Response data:', response.data);
      
      if (response.data) {
        // Handle both response formats
        if (response.data.variables) {
          // Event-specific variables
          console.log('[fetchAvailableVariables] Setting event-specific variables:', Object.keys(response.data.variables).length);
          setAvailableVariables(response.data.variables);
        } else if (response.data.variables_list) {
          // All variables as a list - convert to object format
          const variablesObj = {};
          response.data.variables_list.forEach(v => {
            variablesObj[v.key] = v;
          });
          console.log('[fetchAvailableVariables] Setting all variables from list:', Object.keys(variablesObj).length);
          setAvailableVariables(variablesObj);
        } else if (response.data.variables_by_category) {
          // All variables by category - flatten them
          const variablesObj = {};
          Object.values(response.data.variables_by_category).forEach(category => {
            if (category && typeof category === 'object') {
              Object.entries(category).forEach(([key, value]) => {
                if (key && value) {
                  variablesObj[key] = value;
                }
              });
            }
          });
          console.log('[fetchAvailableVariables] Setting all variables from categories:', Object.keys(variablesObj).length);
          setAvailableVariables(variablesObj);
        }
      }
    } catch (err) {
      console.error('[fetchAvailableVariables] Error fetching available variables:', err);
      console.error('[fetchAvailableVariables] Error details:', err.response?.data);
      // Try to fetch all variables as fallback
      try {
        const fallbackResponse = await api.get('/lms/whatsapp/template-variables/');
        if (fallbackResponse.data) {
          if (fallbackResponse.data.variables_list) {
            const variablesObj = {};
            fallbackResponse.data.variables_list.forEach(v => {
              variablesObj[v.key] = v;
            });
            setAvailableVariables(variablesObj);
          }
        }
      } catch (fallbackErr) {
        console.error('[fetchAvailableVariables] Fallback also failed:', fallbackErr);
      }
    }
  };

  const extractTemplateVariables = (template) => {
    if (!template) {
      console.log('[Template Variables] No template provided');
      return;
    }
    console.log('[Template Variables] Extracting from template:', template.name, template.id);
    setSelectedTemplateForMapping(template);
    const bodyText = template.body_text || '';
    const headerText = template.header_text || '';
    const footerText = template.footer_text || '';
    const fullText = `${headerText} ${bodyText} ${footerText}`;
    
    console.log('[Template Variables] Full text:', fullText);
    
    // Extract all variable numbers like {{1}}, {{2}}, etc.
    const variableMatches = fullText.match(/\{\{(\d+)\}\}/g) || [];
    console.log('[Template Variables] Variable matches:', variableMatches);
    
    const uniqueVariables = [...new Set(variableMatches)]
      .map(match => {
        const numMatch = match.match(/\d+/);
        return numMatch ? numMatch[0] : null;
      })
      .filter(num => num !== null)
      .map(num => parseInt(num))
      .sort((a, b) => a - b);
    
    console.log('[Template Variables] Unique variables:', uniqueVariables);
    setTemplateVariables(uniqueVariables);
    
    // Initialize mapping for new variables
    setTriggerFormData(prev => {
      const newMapping = { ...prev.template_params_mapping };
      uniqueVariables.forEach(varNum => {
        if (!newMapping[varNum]) {
          newMapping[varNum] = '';
        }
      });
      console.log('[Template Variables] Updated mapping:', newMapping);
      return { ...prev, template_params_mapping: newMapping };
    });
  };

  const handleSaveTrigger = async () => {
    if (!id) return;
    if (!triggerFormData.name || !triggerFormData.event_type) {
      setError('Please fill in all required fields');
      return;
    }
    if (!triggerFormData.template && !triggerFormData.template_name) {
      setError('Please select a template');
      return;
    }

    // Parse conditions JSON
    let conditions = {};
    try {
      if (triggerFormData.conditions_json && triggerFormData.conditions_json.trim()) {
        conditions = JSON.parse(triggerFormData.conditions_json);
      }
    } catch (e) {
      setError('Invalid JSON in filter rules. Please check the format.');
      return;
    }

    try {
      setError(null);
      const url = editingTrigger
        ? `/whatsapp/customer-configs/${id}/triggers/${editingTrigger.id}/`
        : `/whatsapp/customer-configs/${id}/triggers/`;
      const method = editingTrigger ? 'put' : 'post';
      
      // Calculate delay_minutes based on delay_type
      let delayMinutes = triggerFormData.delay_minutes || 0;
      if (triggerFormData.delay_type === 'hours') {
        delayMinutes = delayMinutes * 60;
      } else if (triggerFormData.delay_type === 'days') {
        delayMinutes = delayMinutes * 60 * 24;
      }
      
      const payload = {
        ...triggerFormData,
        recipient_type: 'customer', // Always customer
        conditions: conditions,
        template_params_mapping: triggerFormData.template_params_mapping || {},
        delay_minutes: delayMinutes,
      };
      // Remove conditions_json and delay_type from payload
      delete payload.conditions_json;
      delete payload.delay_type;
      
      const response = await api[method](url, payload);
      if (response.data && response.data.success) {
        setSuccess(`Trigger ${editingTrigger ? 'updated' : 'created'} successfully`);
        setTriggerDialogOpen(false);
        await fetchTriggers();
      }
    } catch (err) {
      console.error('Error saving trigger:', err);
      setError(err.response?.data?.error || `Failed to ${editingTrigger ? 'update' : 'create'} trigger`);
    }
  };

  const handleRefreshTemplate = async (template) => {
    const masterId = template.id;
    if (!masterId) return;
    if (!window.confirm(`Are you sure you want to refresh the template "${template.name}"? This will delete the existing template on WhatsApp and create a new one, which will require approval.`)) {
      return;
    }
    try {
      setRefreshingTemplate(masterId);
      setError(null);
      const response = await api.post(`/whatsapp/customer-configs/${id}/templates/refresh-master/`, { master_id: masterId });
      if (response.data && response.data.success) {
        setSuccess(response.data.message || `Template "${template.name}" refreshed successfully. It will be pending approval from WhatsApp.`);
        await fetchTemplates();
      }
    } catch (err) {
      console.error('Error refreshing template:', err);
      setError(err.response?.data?.error || `Failed to refresh template "${template.name}"`);
    } finally {
      setRefreshingTemplate(null);
    }
  };

  const handleDeleteTemplate = async (template) => {
    if (!template.id) return;
    if (!window.confirm(`Are you sure you want to delete the template "${template.name}" from WhatsApp? This action cannot be undone.`)) {
      return;
    }
    try {
      setDeletingTemplate(template.id);
      setError(null);
      const response = await api.delete(`/whatsapp/customer-configs/${id}/templates/${template.id}/`);
      if (response.data && response.data.success) {
        setSuccess(response.data.message || `Template "${template.name}" deleted successfully from WhatsApp.`);
        await fetchTemplates();
      }
    } catch (err) {
      console.error('Error deleting template:', err);
      setError(err.response?.data?.error || `Failed to delete template "${template.name}"`);
    } finally {
      setDeletingTemplate(null);
    }
  };

  const handleSelectConversation = async (conversation) => {
    try {
      const response = await api.get(`/whatsapp/customer-configs/${id}/conversations/${conversation.id}/`);
      if (response.data.success) {
        setSelectedConversation(response.data);
      } else {
        setSelectedConversation(conversation);
      }
    } catch (err) {
      console.error('Error fetching conversation details:', err);
      setSelectedConversation(conversation);
    }
    await fetchMessages(conversation.id);
    setTimeout(() => {
      if (messagesContainerRef.current) {
        messagesContainerRef.current.scrollTo({
          top: messagesContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    }, 200);
  };

  // Refetch conversations when search query changes
  useEffect(() => {
    if (id) {
      const timeoutId = setTimeout(() => {
        fetchConversations();
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [searchQuery, id]);

  const filteredTemplates = templates.filter(template =>
    template.name?.toLowerCase().includes(templateSearchQuery.toLowerCase()) ||
    template.body_text?.toLowerCase().includes(templateSearchQuery.toLowerCase())
  );

  const filteredSyncedTemplates = syncedTemplates.filter(template =>
    template.name?.toLowerCase().includes(templateSearchQuery.toLowerCase()) ||
    template.body_text?.toLowerCase().includes(templateSearchQuery.toLowerCase())
  );

  const filteredConversations = conversations.filter((conv) => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      conv.contact_name?.toLowerCase().includes(query) ||
      conv.contact_phone?.toLowerCase().includes(query) ||
      conv.last_message_preview?.toLowerCase().includes(query) ||
      conv.integration_info?.phone_number?.toLowerCase().includes(query) ||
      conv.integration_info?.display_name?.toLowerCase().includes(query) ||
      conv.lead_info?.name?.toLowerCase().includes(query)
    );
  });

  useEffect(() => {
    if (messagesContainerRef.current && messages.length > 0) {
      setTimeout(() => {
        messagesContainerRef.current?.scrollTo({
          top: messagesContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }, 100);
    }
  }, [messages]);


  const tabs = [
    { label: 'Templates' },
    { label: 'Message Triggers' },
    { label: 'Messages' },
  ];

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 'calc(100vh - 64px)',
        overflow: 'hidden',
        bgcolor: 'background.paper',
      }}
    >
      {/* Header strip - matches customer /whatsapp */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          px: 2,
          py: 1.5,
          borderBottom: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/whatsapp/customer-configs')}
            size="small"
            sx={{ minWidth: 'auto', p: 0, mr: 1 }}
          >
            Back
          </Button>
          {detailLoading ? (
            <CircularProgress size={20} sx={{ mr: 1 }} />
          ) : null}
          <Typography variant="body1" fontWeight={600}>
            {customer.customer_name || customer.company_name || 'Customer'}
          </Typography>
        </Box>
        {detailError ? (
          <Alert severity="error" sx={{ mt: 1 }} onClose={() => setDetailError(null)}>
            {detailError}
          </Alert>
        ) : null}
        <Typography variant="body2" color="text.secondary">
          Manage WhatsApp messages, templates, and automated triggers for this customer
        </Typography>
        {(customer.phone_number || customer.company_name) && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
            {customer.phone_number && `Connected: ${customer.phone_number}`}
            {customer.phone_number && customer.company_name && ' · '}
            {customer.company_name}
          </Typography>
        )}
      </Box>

      {/* Tabs + content - matches customer /whatsapp */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'auto',
          px: 2,
          pt: 1,
          bgcolor: 'background.paper',
        }}
      >
        <Box sx={{ borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
          <Tabs
            value={value}
            onChange={(_, v) => setValue(v)}
            aria-label="whatsapp tabs"
            variant="scrollable"
            scrollButtons="auto"
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} {...a11yProps(index)} />
            ))}
          </Tabs>
        </Box>

        <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <TabPanel value={value} index={2}>
            <Box sx={{ p: 3, width: '100%', height: 'calc(100vh - 240px)', display: 'flex', flexDirection: 'column' }}>
              <Box sx={{ mb: 2, flexShrink: 0 }}>
                <Typography variant="h6" gutterBottom fontWeight="bold">
                  Messages
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  View and manage your WhatsApp conversations
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', flex: 1, minHeight: 0, width: '100%', gap: 2 }}>
                {/* Conversations List - fixed width left panel, always side-by-side */}
                <Paper sx={{ width: 320, minWidth: 280, flexShrink: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <Box sx={{ p: 1.5 }}>
                      <TextField
                        fullWidth
                        placeholder="Search conversations..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Box>
                    <Divider />
                    {loading ? (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, p: 3 }}>
                        <CircularProgress />
                      </Box>
                    ) : filteredConversations.length === 0 ? (
                      <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                        <Typography variant="body2">No conversations found</Typography>
                      </Box>
                    ) : (
                      <List sx={{ overflow: 'auto', flex: 1, py: 0 }} dense>
                        {filteredConversations.map((conversation) => (
                          <ListItem
                            key={conversation.id}
                            button
                            selected={selectedConversation?.id === conversation.id}
                            onClick={() => handleSelectConversation(conversation)}
                            sx={{
                              py: 0.75,
                              px: 1.5,
                              borderBottom: '1px solid',
                              borderColor: 'divider',
                              borderLeft: selectedConversation?.id === conversation.id ? '3px solid' : '3px solid transparent',
                              borderLeftColor: selectedConversation?.id === conversation.id ? 'primary.main' : 'transparent',
                              backgroundColor: selectedConversation?.id === conversation.id ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                              '&:hover': {
                                bgcolor: selectedConversation?.id === conversation.id ? 'rgba(25, 118, 210, 0.12)' : 'action.hover',
                              },
                              '&.Mui-selected': {
                                backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                borderLeftColor: 'primary.main',
                                '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.12)' },
                              },
                            }}
                          >
                            <ListItemAvatar sx={{ minWidth: 40 }}>
                              <Badge badgeContent={conversation.unread_count} color="primary" max={99}>
                                <Avatar sx={{ bgcolor: '#25D366', width: 36, height: 36 }}>
                                  {(conversation.lead_info?.name || conversation.contact_name || conversation.contact_phone)?.charAt(0)?.toUpperCase() || 'U'}
                                </Avatar>
                              </Badge>
                            </ListItemAvatar>
                            <ListItemText
                              primary={
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 0.5 }}>
                                  <Typography variant="body2" fontWeight={conversation.unread_count > 0 ? 600 : 500} noWrap sx={{ flex: 1, fontSize: '0.8125rem' }}>
                                    {conversation.lead_info?.name || conversation.contact_name || conversation.contact_phone}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0, fontSize: '0.7rem' }}>
                                    {formatTime(conversation.last_message_at)}
                                  </Typography>
                                </Box>
                              }
                              secondary={
                                <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block', fontSize: '0.75rem', mt: 0.25 }}>
                                  {conversation.last_message_preview || 'No messages'}
                                </Typography>
                              }
                              primaryTypographyProps={{ noWrap: true }}
                              secondaryTypographyProps={{ noWrap: true }}
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </Paper>

                {/* Message View - right panel, always side-by-side */}
                <Paper sx={{ flex: 1, minWidth: 0, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    {selectedConversation ? (
                      <>
                        <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                              <Avatar sx={{ bgcolor: '#25D366', mr: 2 }}>
                                {(selectedConversation.lead_info?.name || selectedConversation.contact_name || selectedConversation.contact_phone)?.charAt(0)?.toUpperCase() || 'U'}
                              </Avatar>
                              <Box sx={{ flex: 1 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
                                  <Typography variant="subtitle1" fontWeight="bold">
                                    {selectedConversation.lead_info?.name || selectedConversation.contact_name || selectedConversation.contact_phone}
                                  </Typography>
                                  {selectedConversation.integration_info?.phone_number && (
                                    <Chip
                                      label={selectedConversation.integration_info.phone_number}
                                      size="small"
                                      sx={{
                                        height: 22,
                                        fontSize: '0.7rem',
                                        bgcolor: 'primary.light',
                                        color: 'primary.contrastText',
                                        fontWeight: 500,
                                      }}
                                    />
                                  )}
                                </Box>
                                <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                  {selectedConversation.contact_phone}
                                </Typography>
                                {selectedConversation.integration_info?.display_name && selectedConversation.integration_info.display_name !== selectedConversation.integration_info.phone_number && (
                                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontStyle: 'italic' }}>
                                    via {selectedConversation.integration_info.display_name}
                                  </Typography>
                                )}
                                {selectedConversation.lead_info && (
                                  <Typography variant="caption" color="primary.main" sx={{ display: 'block', mt: 0.5, fontWeight: 600 }}>
                                    Lead: {selectedConversation.lead_info.name}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>

                        <Box ref={messagesContainerRef} sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 2 }}>
                          {loadingMessages ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }}>
                              <CircularProgress />
                            </Box>
                          ) : messages.length === 0 ? (
                            <Box sx={{ p: 3, textAlign: 'center', color: 'text.secondary' }}>
                              <Typography variant="body2">No messages yet</Typography>
                            </Box>
                          ) : (
                            messages.map((message) => {
                              const isOutbound = message.direction === 'outbound';
                              const messageContent = message.content || (message.message_type === 'unsupported' ? '[Unsupported message type]' : '[No content]');
                              return (
                                <Box
                                  key={message.id}
                                  sx={{
                                    display: 'flex',
                                    justifyContent: isOutbound ? 'flex-end' : 'flex-start',
                                    mb: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      maxWidth: '70%',
                                      p: 1.5,
                                      borderRadius: 2,
                                      bgcolor: isOutbound ? '#DCF8C6' : 'grey.100',
                                    }}
                                  >
                                    {message.media_url && (
                                      <Box sx={{ mb: 1 }}>
                                        <img src={message.media_url} alt="Media" style={{ maxWidth: '100%', borderRadius: '8px' }} />
                                      </Box>
                                    )}
                                    <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', mb: 0.5 }}>
                                      {messageContent}
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: isOutbound ? 'flex-end' : 'flex-start',
                                        gap: 0.5,
                                        fontSize: '0.7rem',
                                      }}
                                    >
                                      {message.timestamp ? new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                                      {isOutbound && message.status && (
                                        <Box component="span">
                                          {message.status === 'read' ? '✓✓' : message.status === 'delivered' ? '✓✓' : '✓'}
                                        </Box>
                                      )}
                                    </Typography>
                                  </Box>
                                </Box>
                              );
                            })
                          )}
                        </Box>

                        <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
                          <Alert severity="info">
                            To send messages, use WhatsApp templates or initiate conversations from the customer contact in your CRM. (Mock view)
                          </Alert>
                        </Box>
                      </>
                    ) : (
                      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                        <Box sx={{ textAlign: 'center' }}>
                          <WhatsAppIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
                          <Typography variant="h6" color="text.secondary">
                            Select a conversation
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            Choose a conversation from the list to view messages
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </Paper>
              </Box>
            </Box>
          </TabPanel>

          <TabPanel value={value} index={0}>
            <Box sx={{ p: 3 }}>
              <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="h6" gutterBottom fontWeight="bold">
                    Message Templates
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Manage WhatsApp message templates from master library
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  onClick={async () => {
                    try {
                      setSyncing(true);
                      setError(null);
                      const res = await api.post(`/whatsapp/customer-configs/${id}/templates/refresh/`);
                      if (res.data && res.data.success) {
                        const { total_count = 0, synced_count = 0, updated_count = 0 } = res.data;
                        setSuccess(
                          res.data.message || `Synced ${total_count} template(s) from WhatsApp.`
                        );
                        await fetchTemplates();
                      }
                    } catch (err) {
                      setError(err.response?.data?.error || 'Failed to sync templates from WhatsApp');
                    } finally {
                      setSyncing(false);
                    }
                  }}
                  disabled={syncing}
                  sx={{
                    borderColor: '#25D366',
                    color: '#25D366',
                    '&:hover': { borderColor: '#20BA5A', bgcolor: 'rgba(37, 211, 102, 0.04)' },
                  }}
                >
                  {syncing ? 'Syncing...' : 'Sync from WhatsApp'}
                </Button>
              </Box>

              {error && (
                <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
                  {error}
                </Alert>
              )}

              {success && (
                <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess(null)}>
                  {success}
                </Alert>
              )}

              <Box sx={{ mb: 2 }}>
                <TextField
                  fullWidth
                  placeholder="Search templates..."
                  value={templateSearchQuery}
                  onChange={(e) => setTemplateSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  sx={{ bgcolor: 'background.paper' }}
                />
              </Box>

              <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={templateSubTab} onChange={(_, v) => setTemplateSubTab(v)}>
                  <Tab label="Master Templates" id="template-sub-tab-0" aria-controls="template-sub-panel-0" />
                  <Tab label="Templates on WhatsApp" id="template-sub-tab-1" aria-controls="template-sub-panel-1" />
                </Tabs>
              </Box>

              {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <div role="tabpanel" hidden={templateSubTab !== 0} id="template-sub-panel-0" aria-labelledby="template-sub-tab-0">
                    {templateSubTab === 0 && (
                      filteredTemplates.length === 0 ? (
                        <Paper sx={{ p: 4, textAlign: 'center' }}>
                          <Typography variant="body1" color="text.secondary" gutterBottom>
                            {templateSearchQuery
                              ? 'No templates found matching your search.'
                              : 'No templates found. Template masters will appear here once they are created.'}
                          </Typography>
                        </Paper>
                      ) : (
                        <TableContainer component={Paper} variant="outlined">
                          <Table>
                            <TableHead>
                              <TableRow sx={{ bgcolor: 'grey.50' }}>
                                <TableCell sx={{ fontWeight: 600 }}>Template Name</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Sync Status</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Language</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Preview</TableCell>
                                <TableCell sx={{ fontWeight: 600 }} align="right">Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {filteredTemplates.map((template) => {
                                const isSynced = template.is_synced;
                                const syncStatus = template.synced_status || 'NOT_SYNCED';
                                const canSync = template.library_id && !isSynced;
                                const hasChanges = template.has_changes || false;
                                
                                return (
                                  <TableRow 
                                    key={template.id || template.name}
                                    hover
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setSelectedTemplateDetail(template);
                                      setDetailDialogOpen(true);
                                    }}
                                  >
                                    <TableCell>
                                      <Typography variant="body2" fontWeight={500}>
                                        {template.name || 'Untitled Template'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      {isSynced ? (
                                        <Chip
                                          label={syncStatus === 'APPROVED' ? 'Synced' : syncStatus === 'PENDING' ? 'Pending Approval' : syncStatus}
                                          size="small"
                                          color={syncStatus === 'APPROVED' ? 'success' : 'warning'}
                                        />
                                      ) : (
                                        <Chip
                                          label="Not Synced"
                                          size="small"
                                          variant="outlined"
                                          color="default"
                                        />
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      <Chip label={template.category || 'UTILITY'} size="small" variant="outlined" />
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {template.tenant_copy?.language != null && template.tenant_copy?.language !== ''
                                          ? template.tenant_copy.language
                                          : (template.language || 'en_US')}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                              <Typography variant="body2" color="text.secondary" sx={{ 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis', 
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                maxWidth: 400
                              }}>
                                {template.body_text || 'No content'}
                              </Typography>
                            </TableCell>
                            <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                              <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                                <Tooltip title="Edit template wording for this customer">
                                  <Button
                                    size="small"
                                    variant={template.has_tenant_copy ? 'contained' : 'outlined'}
                                    onClick={() => handleOpenTenantCopy(template)}
                                    sx={{ minWidth: '80px' }}
                                  >
                                    Edit
                                  </Button>
                                </Tooltip>
                                {canSync ? (
                                  <Tooltip title="Sync to WhatsApp for this customer">
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      onClick={() => handleSyncTemplate(template)}
                                      disabled={syncingTemplate === template.library_id}
                                      sx={{ 
                                        borderColor: '#25D366', 
                                        color: '#25D366',
                                        '&:hover': { borderColor: '#20BA5A', bgcolor: 'rgba(37, 211, 102, 0.04)' }
                                      }}
                                    >
                                      {syncingTemplate === template.library_id ? 'Syncing...' : 'Sync to WhatsApp'}
                                    </Button>
                                  </Tooltip>
                                ) : (
                                  <>
                                    {isSynced && hasChanges && (
                                      <Tooltip 
                                        title={
                                          template.differences && template.differences.length > 0
                                            ? `Refresh template - Changes detected: ${template.differences.join(', ')}`
                                            : "Refresh template (delete and recreate) - Master has been updated"
                                        }
                                      >
                                        <IconButton
                                          size="small"
                                          onClick={() => handleRefreshTemplate(template)}
                                          disabled={refreshingTemplate === template.id}
                                          sx={{ color: '#ff9800' }}
                                        >
                                          <RefreshIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    )}
                                    <Tooltip title="Send Test">
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          setTestTemplate(template);
                                          setTestPhone('');
                                          const bodyText = template.body_text || '';
                                          const variableMatches = bodyText.match(/\{\{(\d+)\}\}/g) || [];
                                          const uniqueVariables = [...new Set(variableMatches)].sort();
                                          const initialParams = {};
                                          uniqueVariables.forEach((varMatch) => {
                                            const numMatch = varMatch.match(/\d+/);
                                            if (numMatch) {
                                              const varNumber = numMatch[0];
                                              initialParams[varNumber] = '';
                                            }
                                          });
                                          setTemplateParams(initialParams);
                                          setTestDialog(true);
                                        }}
                                        sx={{ color: '#25D366' }}
                                      >
                                        <SendIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </Box>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )
                    )}
                  </div>

                  <div role="tabpanel" hidden={templateSubTab !== 1} id="template-sub-panel-1" aria-labelledby="template-sub-tab-1">
                    {templateSubTab === 1 && (
                      filteredSyncedTemplates.length === 0 ? (
                        <Paper sx={{ p: 4, textAlign: 'center' }}>
                          <Typography variant="body1" color="text.secondary" gutterBottom>
                            {templateSearchQuery
                              ? 'No templates on WhatsApp match your search.'
                              : 'No templates on WhatsApp yet. Use "Sync from WhatsApp" above to pull templates from WhatsApp for this customer.'}
                          </Typography>
                        </Paper>
                      ) : (
                        <TableContainer component={Paper} variant="outlined">
                          <Table>
                            <TableHead>
                              <TableRow sx={{ bgcolor: 'grey.50' }}>
                                <TableCell sx={{ fontWeight: 600 }}>Template Name</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Category</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Language</TableCell>
                                <TableCell sx={{ fontWeight: 600 }}>Preview</TableCell>
                                <TableCell sx={{ fontWeight: 600 }} align="right">Actions</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {filteredSyncedTemplates.map((template) => {
                                const whatsappStatus = template.status || template.synced_status || 'APPROVED';
                                const getStatusColor = (status) => {
                                  switch (status) {
                                    case 'APPROVED':
                                      return 'success';
                                    case 'PENDING':
                                      return 'warning';
                                    case 'REJECTED':
                                      return 'error';
                                    case 'DISABLED':
                                      return 'default';
                                    default:
                                      return 'default';
                                  }
                                };
                                const getStatusLabel = (status) => {
                                  switch (status) {
                                    case 'APPROVED':
                                      return 'Approved';
                                    case 'PENDING':
                                      return 'Pending';
                                    case 'REJECTED':
                                      return 'Rejected';
                                    case 'DISABLED':
                                      return 'Disabled';
                                    default:
                                      return status;
                                  }
                                };
                                return (
                                  <TableRow
                                    key={template.id || template.name}
                                    hover
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setSelectedTemplateDetail(template);
                                      setDetailDialogOpen(true);
                                    }}
                                  >
                                    <TableCell>
                                      <Typography variant="body2" fontWeight={500}>
                                        {template.name || 'Untitled Template'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={getStatusLabel(whatsappStatus)}
                                        size="small"
                                        color={getStatusColor(whatsappStatus)}
                                        variant={whatsappStatus === 'DISABLED' ? 'outlined' : 'filled'}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Chip label={template.category || 'UTILITY'} size="small" variant="outlined" />
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2">
                                        {template.language || 'en_US'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell>
                                      <Typography variant="body2" color="text.secondary" sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        maxWidth: 400
                                      }}>
                                        {template.body_text || 'No content'}
                                      </Typography>
                                    </TableCell>
                                    <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                                      <Tooltip title="Send Test">
                                        <IconButton
                                          size="small"
                                          onClick={() => {
                                            setTestTemplate(template);
                                            setTestPhone('');
                                            const bodyText = template.body_text || '';
                                            const variableMatches = bodyText.match(/\{\{(\d+)\}\}/g) || [];
                                            const uniqueVariables = [...new Set(variableMatches)].sort();
                                            const initialParams = {};
                                          uniqueVariables.forEach((varMatch) => {
                                            const numMatch = varMatch.match(/\d+/);
                                            if (numMatch && numMatch[0]) {
                                              const varNumber = numMatch[0];
                                              initialParams[varNumber] = '';
                                            }
                                          });
                                          setTemplateParams(initialParams);
                                          setTestDialog(true);
                                          }}
                                          sx={{ color: '#25D366' }}
                                        >
                                          <SendIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                      <Tooltip title="Delete from WhatsApp">
                                        <IconButton
                                          size="small"
                                          color="error"
                                          onClick={() => handleDeleteTemplate(template)}
                                          disabled={deletingTemplate === template.id}
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )
                    )}
                  </div>
                </>
              )}

              {/* Template Detail Dialog */}
              <Dialog
                open={detailDialogOpen}
                onClose={() => setDetailDialogOpen(false)}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Typography variant="h6" fontWeight="bold">
                    {selectedTemplateDetail?.name || 'Template Details'}
                  </Typography>
                  <Chip
                    label={selectedTemplateDetail?.status || 'APPROVED'}
                    size="small"
                    color={selectedTemplateDetail?.status === 'APPROVED' ? 'success' : 'warning'}
                  />
                </DialogTitle>
                <DialogContent dividers>
                  {selectedTemplateDetail && (
                    <Box sx={{ pt: 2 }}>
                      <Box sx={{ mb: 3 }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                          Message Body
                        </Typography>
                        <Paper sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                            {selectedTemplateDetail.body_text || 'No content'}
                          </Typography>
                        </Paper>
                      </Box>

                      {selectedTemplateDetail.variable_descriptions && selectedTemplateDetail.variable_descriptions.length > 0 && (
                        <Box sx={{ mb: 3 }}>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Variables
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {selectedTemplateDetail.variable_descriptions.map((varItem, idx) => (
                              <Chip 
                                key={idx}
                                label={`${varItem.var}: ${varItem.description}`}
                                size="small" 
                                variant="outlined"
                                color="primary"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}

                      {selectedTemplateDetail.button_config && selectedTemplateDetail.button_config.buttons && selectedTemplateDetail.button_config.buttons.length > 0 && (
                        <Box sx={{ mb: 3 }}>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Buttons
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {selectedTemplateDetail.button_config.buttons.map((button, idx) => (
                              <Chip 
                                key={idx}
                                label={button.text} 
                                size="small" 
                                variant="outlined"
                                color="secondary"
                              />
                            ))}
                          </Box>
                        </Box>
                      )}

                      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Category
                          </Typography>
                          <Chip label={selectedTemplateDetail.category || 'UTILITY'} size="small" variant="outlined" />
                        </Box>
                        <Box>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Language
                          </Typography>
                          <Chip label={selectedTemplateDetail.language || 'en_US'} size="small" variant="outlined" />
                        </Box>
                      </Box>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button onClick={() => setDetailDialogOpen(false)}>Close</Button>
                  <Button
                    variant="contained"
                    startIcon={<SendIcon />}
                    onClick={() => {
                      if (selectedTemplateDetail) {
                        setTestTemplate(selectedTemplateDetail);
                        setTestPhone('');
                        const bodyText = selectedTemplateDetail.body_text || '';
                        const variableMatches = bodyText.match(/\{\{(\d+)\}\}/g) || [];
                        const uniqueVariables = [...new Set(variableMatches)].sort();
                        const initialParams = {};
                                            uniqueVariables.forEach((varMatch) => {
                                              const numMatch = varMatch.match(/\d+/);
                                              if (numMatch && numMatch[0]) {
                                                const varNumber = numMatch[0];
                                                initialParams[varNumber] = '';
                                              }
                                            });
                                            setTemplateParams(initialParams);
                                            setDetailDialogOpen(false);
                                            setTestDialog(true);
                      }
                    }}
                    sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#20BA5A' } }}
                  >
                    Send Test
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Tenant copy wording dialog */}
              <Dialog
                open={tenantCopyDialogOpen}
                onClose={() => {
                  setTenantCopyDialogOpen(false);
                  setTenantCopyValidationError(null);
                }}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>
                  {tenantCopyTemplateName ? `Edit: ${tenantCopyTemplateName}` : 'Edit template wording'}
                </DialogTitle>
                <DialogContent>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Edit the wording for this customer. Sync to WhatsApp will use this version. Keep variable placeholders like {'{{1}}'}, {'{{2}}'} unchanged and the same count.
                  </Typography>
                  {tenantCopyValidationError && (
                    <Alert severity="error" sx={{ mb: 2 }} onClose={() => setTenantCopyValidationError(null)}>
                      {tenantCopyValidationError}
                    </Alert>
                  )}
                  {loadingTenantCopy ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Box sx={{ pt: 1 }}>
                      <TextField
                        fullWidth
                        label="Header (optional)"
                        value={tenantCopyForm.header_text}
                        onChange={(e) => {
                          setTenantCopyForm((f) => ({ ...f, header_text: e.target.value }));
                          setTenantCopyValidationError(null);
                        }}
                        margin="normal"
                        multiline
                        rows={2}
                      />
                      <TextField
                        fullWidth
                        label="Body"
                        value={tenantCopyForm.body_text}
                        onChange={(e) => {
                          setTenantCopyForm((f) => ({ ...f, body_text: e.target.value }));
                          setTenantCopyValidationError(null);
                        }}
                        margin="normal"
                        multiline
                        rows={6}
                        required
                      />
                      <TextField
                        fullWidth
                        label="Footer (optional)"
                        value={tenantCopyForm.footer_text}
                        onChange={(e) => {
                          setTenantCopyForm((f) => ({ ...f, footer_text: e.target.value }));
                          setTenantCopyValidationError(null);
                        }}
                        margin="normal"
                        multiline
                        rows={2}
                      />
                      <FormControl fullWidth margin="normal">
                        <InputLabel>Language</InputLabel>
                        <Select
                          value={tenantCopyForm.language || ''}
                          label="Language"
                          onChange={(e) => setTenantCopyForm((f) => ({ ...f, language: e.target.value || null }))}
                        >
                          <MenuItem value="">Use master default</MenuItem>
                          <MenuItem value="en">English</MenuItem>
                          <MenuItem value="en_US">English (US)</MenuItem>
                          <MenuItem value="en_IN">English (India)</MenuItem>
                          <MenuItem value="hi">Hindi</MenuItem>
                        </Select>
                      </FormControl>
                      {(tenantCopyForm.variable_descriptions?.length > 0) && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Variable descriptions
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {tenantCopyForm.variable_descriptions.map((varItem, idx) => (
                              <Chip
                                key={idx}
                                label={typeof varItem === 'object' ? `${varItem.var || varItem.name || `{{${idx + 1}}}`}: ${varItem.description || ''}` : String(varItem)}
                                size="small"
                                variant="outlined"
                                color="primary"
                                sx={{ textTransform: 'none' }}
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                      {(tenantCopyForm.button_config?.buttons?.length > 0) && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            Buttons
                          </Typography>
                          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            {tenantCopyForm.button_config.buttons.map((btn, idx) => {
                              const label = typeof btn === 'string' ? btn : (btn?.text || `Button ${idx + 1}`);
                              const typeLabel = typeof btn === 'object' && btn?.type ? btn.type.replace(/_/g, ' ') : 'Quick reply';
                              return (
                                <Chip
                                  key={idx}
                                  label={label}
                                  size="small"
                                  variant="outlined"
                                  color="primary"
                                  sx={{ textTransform: 'none' }}
                                />
                              );
                            })}
                          </Box>
                        </Box>
                      )}
                    </Box>
                  )}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                  <Button onClick={() => setTenantCopyDialogOpen(false)}>Cancel</Button>
                  <Button
                    variant="contained"
                    onClick={handleSaveTenantCopy}
                    disabled={loadingTenantCopy || savingTenantCopy || !tenantCopyForm.body_text?.trim()}
                    sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#20BA5A' } }}
                  >
                    {savingTenantCopy ? 'Saving...' : 'Save'}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* Send Test Dialog */}
              <Dialog
                open={testDialog}
                onClose={() => {
                  setTestDialog(false);
                  setTestTemplate(null);
                  setTestPhone('');
                  setTemplateParams({});
                }}
                maxWidth="sm"
                fullWidth
              >
                <DialogTitle>Send Test Message</DialogTitle>
                <DialogContent>
                  {testTemplate && (
                    <Box sx={{ pt: 2 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Send a test message using template: <strong>{testTemplate.name}</strong>
                      </Typography>
                      
                      <Box sx={{ my: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                          Template Preview:
                        </Typography>
                        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                          {testTemplate.body_text || 'No content'}
                        </Typography>
                      </Box>

                      {/* Template Variable Inputs */}
                      {Object.keys(templateParams).length > 0 && (
                        <Box sx={{ mb: 2 }}>
                          <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                            Template Variables:
                          </Typography>
                          {Object.keys(templateParams)
                            .sort((a, b) => parseInt(a) - parseInt(b))
                            .map((paramKey) => {
                              const varDescription = testTemplate.variable_descriptions?.find(
                                v => v.var === `{{${paramKey}}}`
                              );
                              
                              return (
                                <TextField
                                  key={paramKey}
                                  fullWidth
                                  label={varDescription ? `{{${paramKey}}} - ${varDescription.description}` : `Variable {{${paramKey}}}`}
                                  value={templateParams[paramKey]}
                                  onChange={(e) => setTemplateParams({
                                    ...templateParams,
                                    [paramKey]: e.target.value
                                  })}
                                  margin="normal"
                                  size="small"
                                  required
                                  placeholder={varDescription?.description || `Enter value for {{${paramKey}}}`}
                                />
                              );
                            })}
                        </Box>
                      )}

                      <TextField
                        fullWidth
                        label="Recipient Phone Number"
                        value={testPhone}
                        onChange={(e) => setTestPhone(e.target.value)}
                        placeholder="e.g., +919876543210 or 919876543210"
                        margin="normal"
                        required
                        helperText="Enter phone number with country code (e.g., +919876543210)"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SendIcon />
                            </InputAdornment>
                          ),
                        }}
                      />

                      <Box sx={{ mt: 2, p: 2, bgcolor: 'info.light', borderRadius: 1 }}>
                        <Typography variant="body2" color="info.dark">
                          Note: The template must be APPROVED in WhatsApp Manager to send messages. Test messages will be sent as actual WhatsApp messages.
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </DialogContent>
                <DialogActions>
                  <Button 
                    onClick={() => {
                      setTestDialog(false);
                      setTestTemplate(null);
                      setTestPhone('');
                      setTemplateParams({});
                    }}
                  >
                    Cancel
                  </Button>
                  <Button 
                    variant="contained" 
                    onClick={async () => {
                      if (!testPhone) {
                        setError('Please enter a phone number');
                        return;
                      }
                      
                      // Check if all template parameters are filled
                      const missingParams = Object.keys(templateParams).filter(
                        key => !templateParams[key] || templateParams[key].trim() === ''
                      );
                      if (missingParams.length > 0) {
                        setError(`Please fill all template variables: ${missingParams.map(k => `{{${k}}}`).join(', ')}`);
                        return;
                      }
                      
                      try {
                        setSendingTest(true);
                        setError(null);
                        
                        const response = await api.post(`/whatsapp/customer-configs/${id}/templates/send-test/`, {
                          to_phone: testPhone,
                          template_name: testTemplate.name,
                          template_params: templateParams,
                        });
                        
                        if (response.data && response.data.success) {
                          setSuccess(`Test message sent successfully to ${testPhone}`);
                          setTestDialog(false);
                          setTestPhone('');
                          setTestTemplate(null);
                          setTemplateParams({});
                        } else {
                          setError(response.data?.error || 'Failed to send test message');
                        }
                      } catch (err) {
                        console.error('Error sending test message:', err);
                        setError(err.response?.data?.error || 'Failed to send test message');
                      } finally {
                        setSendingTest(false);
                      }
                    }}
                    disabled={!testPhone || sendingTest || Object.keys(templateParams).some(key => !templateParams[key] || templateParams[key].trim() === '')}
                    startIcon={<SendIcon />}
                    sx={{ 
                      bgcolor: '#25D366',
                      color: 'white',
                      '&:hover': { bgcolor: '#20BA5A' }
                    }}
                  >
                    {sendingTest ? 'Sending...' : 'Send Test'}
                  </Button>
                </DialogActions>
              </Dialog>
            </Box>
          </TabPanel>

          <TabPanel value={value} index={1}>
            <Box sx={{ p: 3 }}>
              {/* Per-tenant event toggles and custom rules */}
              <Paper variant="outlined" sx={{ p: 2, mb: 3, bgcolor: 'grey.50' }}>
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  Event toggles
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                  Enable or disable each event type for this tenant. Optionally set a custom JSON rule (e.g. lead_source, lead_status).
                </Typography>
                {loadingTriggerEventConfigs ? (
                  <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                    <CircularProgress size={24} />
                  </Box>
                ) : (
                  <TableContainer>
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ bgcolor: 'grey.100' }}>
                          <TableCell sx={{ fontWeight: 600 }}>Event</TableCell>
                          <TableCell sx={{ fontWeight: 600 }} align="center" width={100}>On / Off</TableCell>
                          <TableCell sx={{ fontWeight: 600 }} align="center" width={140}>Allowed for Agents</TableCell>
                          <TableCell sx={{ fontWeight: 600 }}>Custom rule (JSON)</TableCell>
                          <TableCell sx={{ fontWeight: 600 }} width={80} align="right">Save</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {triggerEventConfigs.map((config) => (
                          <TableRow key={config.event_key} hover>
                            <TableCell>
                              <Typography variant="body2" fontWeight={500}>
                                {config.label}
                              </Typography>
                            </TableCell>
                            <TableCell align="center">
                              <Switch
                                checked={config.enabled}
                                disabled={savingEventKey === config.event_key}
                                onChange={() => handleEventToggle(config.event_key, !config.enabled)}
                                color="primary"
                                size="small"
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Switch
                                checked={!!config.allowed_for_agent}
                                disabled={savingEventKey === config.event_key}
                                onChange={() =>
                                  updateTriggerEventConfig(config.event_key, {
                                    allowed_for_agent: !config.allowed_for_agent,
                                  })
                                }
                                color="primary"
                                size="small"
                              />
                            </TableCell>
                            <TableCell>
                              <TextField
                                size="small"
                                fullWidth
                                placeholder="{}"
                                value={
                                  config.event_key in eventConfigRuleEdits
                                    ? eventConfigRuleEdits[config.event_key]
                                    : JSON.stringify(config.custom_rule || {}, null, 2)
                                }
                                onChange={(e) =>
                                  setEventConfigRuleEdits((prev) => ({
                                    ...prev,
                                    [config.event_key]: e.target.value,
                                  }))
                                }
                                multiline
                                minRows={1}
                                maxRows={3}
                                sx={{ fontFamily: 'monospace', fontSize: '0.8rem' }}
                              />
                            </TableCell>
                            <TableCell align="right">
                              <Button
                                size="small"
                                variant="outlined"
                                disabled={
                                  savingEventKey === config.event_key ||
                                  !(config.event_key in eventConfigRuleEdits)
                                }
                                onClick={() => handleEventRuleSave(config.event_key)}
                              >
                                {savingEventKey === config.event_key ? '…' : 'Save'}
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Paper>
            </Box>
          </TabPanel>

          {/* Trigger Create/Edit Dialog - Step-by-Step Wizard */}
          <Dialog
            open={triggerDialogOpen}
            onClose={() => setTriggerDialogOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6">
                  {editingTrigger ? 'Edit Message Trigger' : 'Create Message Trigger'}
                </Typography>
                {triggerFormData.name && (
                  <Chip label={triggerFormData.name} size="small" color="primary" />
                )}
              </Box>
            </DialogTitle>
            <DialogContent dividers sx={{ minHeight: '500px' }}>
              <Stepper activeStep={triggerWizardStep} orientation="vertical">
                {/* Step 1: Event */}
                <Step>
                  <StepLabel>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold">1. Event</Typography>
                      {triggerFormData.event_type && <CheckCircleIcon color="success" fontSize="small" />}
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      What system action triggers this?
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mb: 2 }}>
                      <TextField
                        fullWidth
                        label="Trigger Name"
                        value={triggerFormData.name}
                        onChange={(e) => setTriggerFormData({ ...triggerFormData, name: e.target.value })}
                        margin="normal"
                        required
                        helperText="Give your trigger a descriptive name"
                      />
                      <FormControl fullWidth margin="normal" required>
                        <InputLabel>Event Type</InputLabel>
                        <Select
                          value={triggerFormData.event_type}
                          onChange={(e) => {
                            setTriggerFormData({ ...triggerFormData, event_type: e.target.value });
                            fetchAvailableVariables(e.target.value);
                          }}
                          label="Event Type"
                        >
                          <MenuItem value="site_visit_scheduled">Site Visit Scheduled</MenuItem>
                          <MenuItem value="site_visit_reminder">Site Visit Reminder</MenuItem>
                          <MenuItem value="site_visit_completed">Site Visit Completed</MenuItem>
                          <MenuItem value="site_visit_cancelled">Site Visit Cancelled</MenuItem>
                          <MenuItem value="booking_created">Booking Created</MenuItem>
                          <MenuItem value="booking_confirmed">Booking Confirmed</MenuItem>
                          <MenuItem value="payment_received">Payment Received</MenuItem>
                          <MenuItem value="lead_created">Lead Created</MenuItem>
                          <MenuItem value="lead_assigned">Lead Assigned</MenuItem>
                          <MenuItem value="lead_status_changed">Lead Status Changed</MenuItem>
                        </Select>
                      </FormControl>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Recipient: Leads (Customers) only
                      </Typography>
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                          variant="contained"
                          onClick={() => setTriggerWizardStep(1)}
                          disabled={!triggerFormData.name || !triggerFormData.event_type}
                        >
                          Next: Filter Rules
                        </Button>
                      </Box>
                    </Box>
                  </StepContent>
                </Step>

                {/* Step 2: Filter Rules */}
                <Step>
                  <StepLabel>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold">2. Filter Rules</Typography>
                      {triggerFormData.conditions_json && triggerFormData.conditions_json.trim() !== '{}' && <CheckCircleIcon color="success" fontSize="small" />}
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      Which leads qualify?
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Enter filter rules as JSON. Leave empty {} to send to all leads matching the event.
                      </Typography>
                      <TextField
                        fullWidth
                        label="Filter Rules (JSON)"
                        value={triggerFormData.conditions_json}
                        onChange={(e) => {
                          setTriggerFormData({ ...triggerFormData, conditions_json: e.target.value });
                        }}
                        margin="normal"
                        multiline
                        rows={8}
                        helperText="Example: { 'lead_status': 'active', 'lead_source': 'facebook' }"
                        sx={{ fontFamily: 'monospace' }}
                      />
                      <Paper sx={{ p: 2, mt: 2, bgcolor: 'grey.50' }}>
                        <Typography variant="body2" fontWeight="bold" gutterBottom>
                          Example JSON:
                        </Typography>
                        <Typography variant="body2" component="pre" sx={{ fontSize: '0.75rem', fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
{`{
  "lead_status": "active",
  "lead_status__ne": "lost",
  "visit_status": "scheduled"
}`}
                        </Typography>
                      </Paper>
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => setTriggerWizardStep(0)}>Back</Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            // Validate JSON before proceeding
                            try {
                              if (triggerFormData.conditions_json && triggerFormData.conditions_json.trim()) {
                                JSON.parse(triggerFormData.conditions_json);
                              }
                              setTriggerWizardStep(2);
                            } catch (e) {
                              setError('Invalid JSON format. Please check your filter rules.');
                            }
                          }}
                        >
                          Next: Template Mapping
                        </Button>
                      </Box>
                    </Box>
                  </StepContent>
                </Step>

                {/* Step 3: Template Mapping */}
                <Step>
                  <StepLabel>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold">3. Template Mapping</Typography>
                      {triggerFormData.template && <CheckCircleIcon color="success" fontSize="small" />}
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      Which approved template to send?
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mb: 2 }}>
                      <FormControl fullWidth margin="normal" required>
                        <InputLabel>Template</InputLabel>
                        <Select
                          value={triggerFormData.template}
                          onChange={(e) => {
                            const templateId = e.target.value;
                            setTriggerFormData({ ...triggerFormData, template: templateId });
                            if (templateId) {
                              const template = syncedTemplates.find(t => String(t.id) === templateId);
                              if (template) {
                                extractTemplateVariables(template);
                              }
                            } else {
                              setTemplateVariables([]);
                              setSelectedTemplateForMapping(null);
                            }
                          }}
                          label="Template"
                        >
                          <MenuItem value="">Select a template...</MenuItem>
                          {syncedTemplates
                            .filter(t => t.status === 'APPROVED')
                            .map((template) => (
                              <MenuItem key={template.id} value={String(template.id)}>
                                {template.name} ({template.language || 'en_US'})
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                      {!triggerFormData.template && (
                        <TextField
                          fullWidth
                          label="Template Name (if template not selected)"
                          value={triggerFormData.template_name}
                          onChange={(e) => setTriggerFormData({ ...triggerFormData, template_name: e.target.value })}
                          margin="normal"
                          helperText="Enter template name if template is not in the list above"
                        />
                      )}
                      
                      {/* Variable Mapping Section - Show when template has variables */}
                      {templateVariables.length > 0 && (
                        <Box sx={{ mt: 3, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                            <Box>
                              <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
                                Map Template Variables
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                Map each template variable to a data field. The template will use these values when sending messages.
                              </Typography>
                            </Box>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => {
                                  if (triggerFormData.event_type) {
                                    fetchAvailableVariables(triggerFormData.event_type);
                                  } else {
                                    fetchAvailableVariables(null);
                                  }
                                }}
                                sx={{ ml: 2 }}
                              >
                                Refresh Variables
                              </Button>
                              {id && (
                                <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
                                  Account ID: {id}
                                </Typography>
                              )}
                          </Box>
                          
                          {triggerFormData.event_type && (
                            <Typography variant="caption" color="text.secondary" sx={{ mb: 2, display: 'block' }}>
                              Event Type: <strong>{triggerFormData.event_type}</strong> | Available variables: {Object.keys(availableVariables).length}
                            </Typography>
                          )}
                          
                          {selectedTemplateForMapping && (
                            <Paper sx={{ p: 2, mb: 2, bgcolor: 'grey.50' }}>
                              <Typography variant="caption" fontWeight="bold" gutterBottom>
                                Template Preview:
                              </Typography>
                              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', fontSize: '0.875rem' }}>
                                {selectedTemplateForMapping.body_text || 'No content'}
                              </Typography>
                            </Paper>
                          )}
                          
                          {Object.keys(availableVariables).length === 0 && (
                            <Alert severity="warning" sx={{ mb: 2 }}>
                              <AlertTitle>No Variables Available</AlertTitle>
                              <Typography variant="body2">
                                {triggerFormData.event_type 
                                  ? `No variables found for event type "${triggerFormData.event_type}". Click "Refresh Variables" to try again or check if the event type is correct.`
                                  : 'Please select an event type first to see available variables.'}
                              </Typography>
                              <Button
                                size="small"
                                variant="outlined"
                                onClick={() => {
                                  if (triggerFormData.event_type) {
                                    fetchAvailableVariables(triggerFormData.event_type);
                                  } else {
                                    fetchAvailableVariables(null);
                                  }
                                }}
                                sx={{ mt: 1 }}
                              >
                                Load Variables
                              </Button>
                              {id && (
                                <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                                  Account ID: {id}
                                </Typography>
                              )}
                            </Alert>
                          )}
                          
                          {templateVariables.map((varNum) => {
                            const variableOptions = Object.keys(availableVariables).map(key => ({
                              value: key,
                              label: availableVariables[key].label || key,
                              description: availableVariables[key].description || '',
                              example: availableVariables[key].example || '',
                            })).sort((a, b) => a.label.localeCompare(b.label));
                            
                            return (
                              <Box key={varNum} sx={{ mb: 2 }}>
                                <FormControl fullWidth>
                                  <InputLabel>Template Variable {`{{${varNum}}}`}</InputLabel>
                                  <Select
                                    value={triggerFormData.template_params_mapping[varNum] || ''}
                                    onChange={(e) => {
                                      const newMapping = {
                                        ...triggerFormData.template_params_mapping,
                                        [varNum]: e.target.value,
                                      };
                                      setTriggerFormData({
                                        ...triggerFormData,
                                        template_params_mapping: newMapping,
                                      });
                                    }}
                                    label={`Template Variable {{${varNum}}}`}
                                    disabled={variableOptions.length === 0}
                                  >
                                    <MenuItem value="">
                                      <em>Select a data field...</em>
                                    </MenuItem>
                                    {variableOptions.length === 0 ? (
                                      <MenuItem disabled>
                                        <Typography variant="body2" color="text.secondary">
                                          No variables available. Please check event type.
                                        </Typography>
                                      </MenuItem>
                                    ) : (
                                      variableOptions.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                          <Box>
                                            <Typography variant="body2">{option.label}</Typography>
                                            {option.description && (
                                              <Typography variant="caption" color="text.secondary" display="block">
                                                {option.description}
                                              </Typography>
                                            )}
                                          </Box>
                                        </MenuItem>
                                      ))
                                    )}
                                  </Select>
                                  {triggerFormData.template_params_mapping[varNum] && availableVariables[triggerFormData.template_params_mapping[varNum]] && (
                                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                                      Example: {availableVariables[triggerFormData.template_params_mapping[varNum]].example || 'N/A'}
                                    </Typography>
                                  )}
                                </FormControl>
                              </Box>
                            );
                          })}
                        </Box>
                      )}
                      
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => setTriggerWizardStep(1)}>Back</Button>
                        <Button
                          variant="contained"
                          onClick={() => setTriggerWizardStep(3)}
                          disabled={
                            !triggerFormData.template && !triggerFormData.template_name ||
                            (templateVariables.length > 0 && !templateVariables.every(v => triggerFormData.template_params_mapping[v]))
                          }
                        >
                          Next: Delay Configuration
                        </Button>
                      </Box>
                    </Box>
                  </StepContent>
                </Step>

                {/* Step 4: Delay Configuration */}
                <Step>
                  <StepLabel>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold">4. Delay Configuration</Typography>
                      {triggerFormData.delay_minutes > 0 && <CheckCircleIcon color="success" fontSize="small" />}
                    </Box>
                    <Typography variant="caption" color="text.secondary">
                      When exactly to send?
                    </Typography>
                  </StepLabel>
                  <StepContent>
                    <Box sx={{ mb: 2 }}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={triggerFormData.delay_before_event}
                            onChange={(e) => setTriggerFormData({ ...triggerFormData, delay_before_event: e.target.checked })}
                          />
                        }
                        label="Send before event (e.g., 24 hours before site visit)"
                        sx={{ mb: 2 }}
                      />
                      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <TextField
                          type="number"
                          label="Delay Amount"
                          value={triggerFormData.delay_minutes}
                          onChange={(e) => setTriggerFormData({ ...triggerFormData, delay_minutes: parseInt(e.target.value) || 0 })}
                          margin="normal"
                          inputProps={{ min: 0 }}
                          sx={{ flex: 1 }}
                        />
                        <FormControl margin="normal" sx={{ minWidth: 120 }}>
                          <InputLabel>Unit</InputLabel>
                          <Select
                            value={triggerFormData.delay_type}
                            onChange={(e) => setTriggerFormData({ ...triggerFormData, delay_type: e.target.value })}
                            label="Unit"
                          >
                            <MenuItem value="minutes">Minutes</MenuItem>
                            <MenuItem value="hours">Hours</MenuItem>
                            <MenuItem value="days">Days</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                        Example: 24 hours before visit_datetime
                      </Typography>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={triggerFormData.is_active}
                            onChange={(e) => setTriggerFormData({ ...triggerFormData, is_active: e.target.checked })}
                          />
                        }
                        label="Activate this trigger immediately"
                        sx={{ display: 'block', mt: 2 }}
                      />
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={() => setTriggerWizardStep(2)}>Back</Button>
                        <Button
                          variant="contained"
                          onClick={handleSaveTrigger}
                          sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#20BA5A' } }}
                        >
                          {editingTrigger ? 'Update Trigger' : 'Create Trigger'}
                        </Button>
                      </Box>
                    </Box>
                  </StepContent>
                </Step>
              </Stepper>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setTriggerDialogOpen(false)}>Cancel</Button>
            </DialogActions>
          </Dialog>

        </Box>
      </Box>
    </Container>
  );
};

export default CustomerConfigDetail;
